import { put, takeEvery } from 'redux-saga/effects'

import { submitSearchLight } from '@redux/actions/searchlight'
import {
  ON_SUBMIT_SEARCHLIGHT,
  SEARCHLIGHT_SUBMIT_FAIL
} from '@redux/actions/types'
import { toast } from 'react-toastify'

/**
 * Dispatches the API action to submit a Searchlight scenario.
 * @param action
 */
function * onScenarioSubmit(action) {
  const { auth, data } = action.payload
  yield put(submitSearchLight({ auth, data }))
}

/**
 * Shows a warning toast when a Searchlight scenario submission fails.
 */
function onScenarioSubmitFail() {
  toast.warn('Error submitting scenario')
}

/**
 * Root saga that watches for Searchlight-related actions.
 */
function * watchSearchlight() {
  yield takeEvery(ON_SUBMIT_SEARCHLIGHT, onScenarioSubmit)
  yield takeEvery(SEARCHLIGHT_SUBMIT_FAIL, onScenarioSubmitFail)
}

export default watchSearchlight
